import { gql } from '@apollo/client';

export const GetUserBookingQuery = gql`
  query GetUserBooking {
    getUserBooking {
      id
      startsAt
      endsAt
      gate {
        id
        description
      }
      parking {
        id
        name
      }
    }
  }
`;
